import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncDevtoolsPanel = Loadable({
  loader: () => import( /* webpackChunkName: "collab-sidebar-devtools" */'./DevtoolsPanel').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncDevtoolsPanel;